/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Timeout7Inputs */

const en_us2_body_assessment_error_timeout7 = /** @type {(inputs: Body_Assessment_Error_Timeout7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The calculation took longer than the time limit. Send the photos again in a few moments.`)
};

const pt_br2_body_assessment_error_timeout7 = /** @type {(inputs: Body_Assessment_Error_Timeout7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O cálculo demorou mais que o tempo limite. Envie as fotos de novo em alguns instantes.`)
};

const es_419_body_assessment_error_timeout7 = /** @type {(inputs: Body_Assessment_Error_Timeout7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El cálculo tardó más que el tiempo límite. Vuelve a enviar las fotos en unos momentos.`)
};

const pt_pt2_body_assessment_error_timeout7 = /** @type {(inputs: Body_Assessment_Error_Timeout7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O cálculo demorou mais do que o tempo limite. Envia as fotos de novo daqui a uns instantes.`)
};

const fr_fr2_body_assessment_error_timeout7 = /** @type {(inputs: Body_Assessment_Error_Timeout7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le calcul a dépassé le temps limite. Renvoie les photos dans quelques instants.`)
};

const de_de2_body_assessment_error_timeout7 = /** @type {(inputs: Body_Assessment_Error_Timeout7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Berechnung hat das Zeitlimit überschritten. Sende die Fotos in ein paar Augenblicken erneut.`)
};

const it_it2_body_assessment_error_timeout7 = /** @type {(inputs: Body_Assessment_Error_Timeout7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il calcolo ha superato il tempo limite. Invia di nuovo le foto tra qualche istante.`)
};

/**
* | output |
* | --- |
* | "The calculation took longer than the time limit. Send the photos again in a few moments." |
*
* @param {Body_Assessment_Error_Timeout7Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_timeout7 = /** @type {((inputs?: Body_Assessment_Error_Timeout7Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Timeout7Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_timeout7(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_timeout7(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_timeout7(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_timeout7(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_timeout7(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_timeout7(inputs)
	return en_us2_body_assessment_error_timeout7(inputs)
});
export { body_assessment_error_timeout7 as "body-assessment.error.TIMEOUT" }